
const USER_ROLES = ['ADMIN', 'EDITOR', 'GUEST']

const ENTRIES_SCOPES = ['ADD', 'EDIT', 'REMOVE']

export { USER_ROLES, ENTRIES_SCOPES }